import Firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCSC7ow38QVSa_8Q4_mYIdrVahnRvP33x0",
  authDomain: "eyalacademyeg.firebaseapp.com",
  projectId: "eyalacademyeg",
  storageBucket: "eyalacademyeg.appspot.com",
  messagingSenderId: "572488413032",
  appId: "1:572488413032:web:93d85f5d308cfcfbd670dd"
};

// Initialize Firebase
const firebase = Firebase.initializeApp(firebaseConfig);

export { firebase };
